<div class="dropdown" dropdown *ngIf="projectList.length > 1">
    <button type="button" class="btn header-item" dropdownToggle data-toggle="dropdown" aria-haspopup="false"
        aria-expanded="false">
        <i class="bx bxl-product-hunt"></i>
        {{ selectedProject ? selectedProject.projectName : '' }}
        <i class="mdi mdi-chevron-down"></i>
    </button>
    <div class="dropdown-menu" *dropdownMenu style="max-height: 50vh;overflow: auto;">
        <dropdown-item *ngFor="let project of projectList"
            (click)="selectedProject = project;selectionChanged(project.id)">
            {{ project.projectName }}
        </dropdown-item>
    </div>
</div>